<div class="container">

  <div class="table-section">
    <h2 class="section-title">UNREAD NOTIFICATIONS</h2>
    <ag-grid-angular
      style="width: 100%; height: 300px"
      [columnDefs]="unreadColDefs"
      [defaultColDef]="defaultColDef"
      [suppressCellFocus]="true"
      [theme]="theme"
      [gridOptions]="unreadGridOptions"
      (cellClicked)="onUnreadCellClicked($event)"
    />
  </div>

  <div class="table-section">
    <h2 class="section-title">ARCHIVED NOTIFICATIONS</h2>
    <ag-grid-angular
      style="width: 100%; height: 300px"
      [columnDefs]="archivedColDefs"
      [defaultColDef]="defaultColDef"
      [suppressCellFocus]="true"
      [theme]="theme"
      [gridOptions]="archivedGridOptions"
      (cellClicked)="onArchivedCellClicked($event)"
    />
  </div>

</div>
